import HeaderEditor from './HeaderEditor.vue';
import HeroEditor from './HeroEditor.vue';
import BannersEditor from './BannersEditor.vue';
import QuickAccessEditor from './QuickAccessEditor.vue';
import AcademicSystemsEditor from './AcademicSystemsEditor.vue';
import AcademicYearsEditor from './AcademicYearsEditor.vue';
import CoursesEditor from './CoursesEditor.vue';
import StatsEditor from './StatsEditor.vue';
import TestimonialsEditor from './TestimonialsEditor.vue';
import CtaEditor from './CtaEditor.vue';
import FooterEditor from './FooterEditor.vue';

/**
 * Maps a homepage_sections `type` to the editor dialog that manages it — an
 * object map, not an if/else chain (same principle as sectionRegistry.js on
 * the public site). `home_products` isn't listed here since it needs
 * disambiguation by settings.kind first — see index.vue's `activeEditor`
 * computed, which resolves academic_years vs courses before falling back to
 * this map for every other type.
 */
export const editorRegistry = {
  header: HeaderEditor,
  hero: HeroEditor,
  banners: BannersEditor,
  quick_access: QuickAccessEditor,
  academic_systems: AcademicSystemsEditor,
  academic_years: AcademicYearsEditor,
  courses: CoursesEditor,
  statistics: StatsEditor,
  testimonials: TestimonialsEditor,
  cta: CtaEditor,
  footer: FooterEditor,
};
